'use es6';

import { isFailed, isStarted } from 'conversations-async-data/async-data/operators/statusComparators';
import { connect } from 'react-redux';
import { getSessionId } from '../../selectors/widgetDataSelectors/getSessionId';
import { fetchThreadHistory } from '../../thread-histories/actions/fetchThreadHistory';
import ThreadHistoryFetcher from '../components/ThreadHistoryFetcher';
import { getCurrentThreadHistoryData } from '../selectors/getCurrentThreadHistoryData';
import { getCurrentThreadHistoryEntry } from '../selectors/getCurrentThreadHistoryEntry';
import { getCurrentThreadId } from '../selectors/getCurrentThreadId';
import { getInputFocus } from '../../visitor-widget/selectors/getInputFocus';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { getShouldHideScrollButton } from '../../selectors/getShouldHideScrollButton';
const mapStateToProps = state => {
  const threadHistoryAsyncData = getCurrentThreadHistoryEntry(state);
  return {
    isLoadingHistory: isStarted(threadHistoryAsyncData),
    loadingHistoryFailed: isFailed(threadHistoryAsyncData),
    sessionId: getSessionId(state),
    threadHistory: getCurrentThreadHistoryData(state),
    threadId: getCurrentThreadId(state),
    isOnFocus: getInputFocus(state),
    coloring: getColoring(state),
    hideScrollToButton: getShouldHideScrollButton(state)
  };
};
const mapDispatchToProps = {
  fetchThreadHistory
};
export default connect(mapStateToProps, mapDispatchToProps)(ThreadHistoryFetcher);